import { render, staticRenderFns } from "./Beacon.vue?vue&type=template&id=12aed7bd&scoped=true"
import script from "./Beacon.vue?vue&type=script&lang=js"
export * from "./Beacon.vue?vue&type=script&lang=js"
import style0 from "./Beacon.vue?vue&type=style&index=0&id=12aed7bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aed7bd",
  null
  
)

export default component.exports